import React from "react";
import { Link } from "react-router-dom";
import { Redirect } from "react-router-dom";
import "./Tipo.css";

// Antes cada opcion era una imagen con el texto dentro (sin acentos y con "INTERSEMETRALES"); el lector de
// pantalla no la anunciaba y en celular cada imagen ocupaba casi toda la pantalla. Ahora son botones con texto
// y un icono dibujado, con los mismos colores.

const trazo = { fill: "none", stroke: "currentColor", strokeWidth: 2.2, strokeLinecap: "round", strokeLinejoin: "round" };

const IconoExamen = () => (
  <svg viewBox="0 0 48 48" {...trazo}>
    <path d="M12 5h18l8 8v30H12z" />
    <path d="M30 5v8h8" />
    <circle cx="19" cy="20" r="2.2" />
    <path d="M25 20h8" />
    <path d="M17 28.5l2 2 3.5-4" />
    <path d="M25 29h8" />
    <circle cx="19" cy="37" r="2.2" />
    <path d="M25 37h8" />
  </svg>
);

const IconoEgresados = () => (
  <svg viewBox="0 0 48 48" {...trazo}>
    <path d="M3 18l21-9 21 9-21 9z" />
    <path d="M12 22v10c0 3 5.5 6 12 6s12-3 12-6V22" />
    <path d="M42 19.5V31" />
    <circle cx="42" cy="33" r="1.8" />
  </svg>
);

const IconoOtros = () => (
  <svg viewBox="0 0 48 48" {...trazo}>
    <rect x="6" y="9" width="36" height="30" rx="4" />
    <circle cx="18" cy="21" r="4.5" />
    <path d="M10.5 33c1-4 4-6 7.5-6s6.5 2 7.5 6" />
    <path d="M29 19h8" />
    <path d="M29 25h8" />
    <path d="M29 31h5" />
  </svg>
);

export const OPCIONES = [
  {
    ruta: "/formulario-examenes",
    nombre: "Exámenes extraordinarios y cursos intersemestrales",
    detalle: "Paga tu examen extraordinario o tu curso intersemestral.",
    Icono: IconoExamen,
    color: "azul",
  },
  {
    ruta: "/formulario-diplomas",
    nombre: "Paquete de egresados",
    detalle: "Certificado de terminación, constancias y diplomas.",
    Icono: IconoEgresados,
    color: "verde",
  },
  {
    ruta: "/formulario-otros",
    nombre: "Otros servicios",
    detalle: "Gastos de administración, constancias, kardex, credencial y más trámites.",
    Icono: IconoOtros,
    color: "azul",
  },
];

const Tipo = ({ alumno, cambiarTablaConceptos, cambiarPrecio = () => {}, cambiarClaves = () => {}, cambiarChecked = () => {}, cambiarPagar = () => {} }) => {
  // Al elegir un tipo de pago se empieza una seleccion nueva (antes lo hacia cada formulario al abrirse, y por
  // eso al regresar desde Forma de pago se perdia lo que el alumno habia marcado)
  const empezarSeleccion = () => {
    cambiarTablaConceptos([]);
    cambiarPrecio(0);
    cambiarClaves([]);
    cambiarChecked({});
    cambiarPagar(false);
  };

  return alumno.codigo === "" ? (
    <Redirect to="/login" />
  ) : (
    <div className="Tipo container">
      <h1 className="Tipo-titulo">¿Qué deseas pagar?</h1>
      <nav className="Tipo-flex" aria-label="Tipos de pago">
        {OPCIONES.map(({ ruta, nombre, detalle, Icono, color }) => (
          <Link key={ruta} className={`Tipo-seleccion Tipo-seleccion--${color}`} to={ruta} onClick={empezarSeleccion}>
            <span className="Tipo-icono" aria-hidden="true"><Icono /></span>
            <span className="Tipo-texto">
              <span className="Tipo-nombre">{nombre}</span>
              <span className="Tipo-detalle">{detalle}</span>
            </span>
            <span className="Tipo-flecha" aria-hidden="true">›</span>
          </Link>
        ))}
      </nav>
    </div>
  );
};

export default Tipo;
